import BodyCopy from './component.styles'
export default BodyCopy
